<template>
    <div style="display: flex; flex-direction: column; height: 100%; background-color: #111318;">
        <div style="left: 59%; transform: translateX(-50%); top: 70px;" class="blob_circle"></div>
        <MercenaryHeader :isExpert="true" :isBlur="true" :back-title="'뒤로가기'" :title="'시크릿 입단 요청서'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>

        <div style="flex: 1; overflow: auto; padding: 0 24px; position: relative; z-index: 1;">
            <div style="text-align: center; margin-top: 40px;">
                <div style="font-size: 32px; font-weight: 700; line-height: 40px; color: #FFF;">완벽합니다!</div>
                <div style="font-size: 24px; font-weight: 700; line-height: 40px; color: #fff;">시크릿 입단 요청서가 완성되었어요.</div>
                <div style="font-weight: 500; line-height: 24px; color: #fff;">이적시장에는 이렇게 노출이 됩니다.</div>
            </div>

            <div class="background_glass" style="margin-top: 17px; border-radius: 18px; overflow: hidden; padding: 20px 12px; ">
                <div style="border-radius: 16px;">
                    <div style="display: flex; align-items: flex-start; gap: 10px;">
                        <ProfileImage :image-path="null" style="width: 40px;"></ProfileImage>
                        <div style="flex: 1; margin-top: 4px;">
                            <div style="display: flex; align-items: center; gap: 6px;">
                                <div style="font-size: 12px; font-weight: 700; line-height: 16px; color: #fff;">주**</div>
                                <div>
                                    <img style="width: 13px;" :src="require('@/assets/img/verified_parent.png')" alt="">
                                </div>
                            </div>
                        </div>
                        <div style="flex-shrink: 0; border-radius: 10px; padding: 6px 10px; background: linear-gradient(360deg, #210F03 0%, #6A6A6A 100%);">
                            <div style="font-size: 14px; font-weight: 900; line-height: 16px; color: rgba(255,255,255,0.92); text-align: center;">U15</div>
                            <div style="margin-top: 2px; font-size: 12px; font-weight: 700; line-height: 16px; color: var(--color-main); text-align: center;">엘리트 선수</div>
                        </div>
                    </div>

                    <div style="margin-top: 14px; border-radius: 14px; background: #9E4CF61A; padding: 12px 10px; display: flex; align-items: center;">
                        <div style="flex: 1; display: flex; flex-direction: column; align-items: center; gap: 4px;">
                            <div class="stat_label">포지션</div>
                            <div class="stat_value">FW</div>
                        </div>
                        <div class="stat_divider"></div>
                        <div style="flex: 1; display: flex; flex-direction: column; align-items: center; gap: 4px;">
                            <div class="stat_label">신장</div>
                            <div class="stat_value">176cm</div>
                        </div>
                        <div class="stat_divider"></div>
                        <div style="flex: 1; display: flex; flex-direction: column; align-items: center; gap: 4px;">
                            <div class="stat_label">체중</div>
                            <div class="stat_value">65kg</div>
                        </div>
                        <div class="stat_divider"></div>
                        <div style="flex: 1; display: flex; flex-direction: column; align-items: center; gap: 4px;">
                            <div class="stat_label">주발</div>
                            <div class="stat_value">오른발</div>
                        </div>
                    </div>

                    <div style="margin-top: 12px;">
                        <div class="region_section">
                            <div style="background: #9E4CF633;" class="region_common_wrapper">
                                <div>
                                    <img style="width: 12px;" :src="require('@/assets/img/region_icon_white.png')" alt="">
                                </div>
                                <div style="font-weight: 700;">희망 지역</div>
                            </div>
                            <div style="background: #210F031A;" class="region_common_wrapper" v-for="each, i in ['인천', '한국']" :key="i + 'region_list'">
                                <div>
                                    {{ each }}
                                </div>
                            </div>
                        </div>
                        <div style="margin-top: 10px; font-weight: 700; line-height: 24px; color: #fff;">“스피드 6.3초, 공간간 침투를 잘하는 윙어”</div>
                        <div class="blur_text ellipsis" style="margin-top: 14px;">
                            짧은 자기소개/선수 특징이 이 영역에 들어갑니다. 사진과 동일한 형태로 프리뷰가 노출되도록 구성했어요.
                        </div>
                    </div>
                </div>
            </div>

        </div>
        
        <div style="text-align: center; font-size: 12px; font-weight: 500; line-height: 24px; color: #fff;">
            사커하우가 선수님의 빛나는 꿈을 진심으로 응원합니다! ⚽✨
        </div>
        <div style="padding: 10px 16px 18px 16px; background-color: #111318;">
            <div
                @click="checkPayAvailable"
                style="height: 52px; fake-width: 15px; border-radius: 14px; background: #A855F7; display: flex; align-items: center; justify-content: center; color: #fff; font-weight: 900; font-size: 16px; cursor: pointer; user-select: none;"
            >
                29,000원 결제하기
            </div>
        </div>
    </div>
</template>

<script>
    import ResponseCode from "@/ResponseCode";
    import moment from 'moment';
    import MercenaryHeader from "@/components/common/MercenaryHeader.vue";
    import ProfileImage from "@/components/common/ProfileImage.vue";

    export default {
        name: "TestSecretPay",
        components: {
            MercenaryHeader,
            ProfileImage
        },
        //TODO 데이터 지정
        data(){
            return {
                amt : 1000,
                wait_interval : null
            }
        },
        //TODO 필히 넣어줄것
        beforeDestroy(){
            if(this.wait_interval) clearInterval(this.wait_interval);
        },
        methods : {
            async checkPayAvailable(){
                const parameters = {};
                parameters.from = 'secret';
                const res = await this.$Axios.get('/api/pay/request/join/check', {params : parameters});
                console.log(res.data);
                const code = res.data.code;
                if (code === ResponseCode.SUCCESS) {
                    console.log('결제창');
                    this.showPayment();
                    //가족 결제부터
                } else if (code === 1) {
                    console.log('가족 결제창');
                    this.showParentPayPop()
                    //가족 등록부터
                } else if (code === 2) {
                    console.log('가족 등록창')
                    this.$GlobalStore.addModal('ParentAuth', {
                        completeAction : () => {
                            this.showParentPayPop()
                        }
                    });
                }
            },
            showPayment() {
                if (!this.$Util.checkLogin()) return;

                this.$GlobalStore.addModal('Payment', { payAction: this.payAction, goods_name: '시크릿 입단 요청서', amt: this.amt });
            },
            async payAction(pay_method, pay_mode, card_idx) {
                //사전 검증
                // const before_parameters = {};
                // before_parameters.to_member_idx = this.selectedTeam.manager_idx;
                // const validation_res = await this.$Axios.get('/api/pay/direct/message/save/before', {params : before_parameters});
                // if(validation_res.data.code === ResponseCode.FAIL) {
                //     this.$GlobalStore.showAlert(validation_res.data.msg);
                //     return;
                // }

                const parameters = {};
                parameters.pay_mode = pay_mode;
                // amt 실제결제금액
                parameters.amt = this.amt;
                parameters.goods_name = '시크릿 입단 요청서';
                parameters.card_idx = card_idx;

                await this.$Util.payIntegrated(pay_method, parameters, async (converted_parameters) => {
                    return await this.$Axios.post('/api/pay/soccerhow/secret/save', converted_parameters);
                }, async (converted_parameters) => {
                    const res = await this.$Axios.post('/api/pay/soccerhow/secret/save', converted_parameters);
                    if (res.data.code === ResponseCode.SUCCESS) {
                        // this.$GlobalStore.closeModalAll()
                        const payMethodObj = {
                            pay_method: pay_method,
                            goods_name: '시크릿 입단 요청서',
                            amt: this.amt,
                            pay_info: res.data.pay_info
                        }
                        this.$Util.sendEventClick('시크릿_입단_요청서_결제', true)
                        this.$GlobalStore.addModal('CompletePayNew', { payMethodObj: payMethodObj, isModalBackTransparent: true})
                    } else if (res.data.code === ResponseCode.FAIL) {
                        this.$GlobalStore.showAlert(res.data.msg);
                    }
                }, async () => {
                    //TODO 사커하우 글 저장
                    const result = await this.completeAction();
                    return [true, { refer_idx: result.data.insertedSoccerHowIdx }];
                })
            },
            async showParentPayPop(){
                const parameters = {};
                parameters.member_idx = this.$GlobalStore.loginInfo().idx;
                const res = await this.$Axios.get('/api/member/family/mine', {params : parameters});
                const member_families = res.data.member_family;
                if(member_families.length === 0){
                    this.$GlobalStore.showAlert('등록된 가족이 없습니다.');
                    return;
                }

                const member_family = member_families[0];

                this.$GlobalStore.addModal('ParentPayWait', {
                    name : member_family.nic_name,
                    phone : member_family.phone,
                    amt : this.amt,
                    payDirectly : () => {
                        this.$GlobalStore.closeLastModal();
                        this.showPayment();
                    },
                    payByParent : async () => {
                        const result = await this.completeAction();
                        const soccerhow_idx = result.data.insertedSoccerHowIdx;

                        const parameters = {};
                        parameters.soccerhow_idx = soccerhow_idx;
                        const res = await this.$Axios.post('/api/pay/soccerhow/secret/parent_sms/send', parameters);
                        if(res.data.code === -1){
                            this.$GlobalStore.showAlert(res.data.msg);
                            return;
                        }

                        this.wait_interval = setInterval(() => {
                            console.log('결제 완료 여부 체크');
                            this.checkPaid(soccerhow_idx)
                        }, 3000);
                    }
                });
            },
            async checkPaid(soccerhow_idx){
                const parameters = {};
                parameters.soccerhow_idx = soccerhow_idx;
                const res = await this.$Axios.get('/api/soccerhow/secret/paid', {params : parameters});
                if(res.data.is_paid){
                    clearInterval(this.wait_interval);
                    this.$GlobalStore.closeLastModal();
                    const payMethodObj = {
                        pay_method: '',
                        goods_name: '시크릿 입단 요청서',
                        amt: this.amt,
                        pay_info: {
                            pay_date : moment().format('YYYY-MM-DD HH:mm:ss')
                        }
                    }
                    this.$GlobalStore.addModal('CompletePayNew', { payMethodObj: payMethodObj, isModalBackTransparent: true})
                }
            },
            //TODO 사커하우 작성후 응답줘야할 데이터
            completeAction(){
                return {
                    data : {
                        insertedSoccerHowIdx : '5368'
                    }
                }
            }
        }


    }
</script>

<style scoped>
.background_glass {
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}
.blob_circle {
    position: fixed;
    width: 120%;
    height: 366px;
    border-radius: 50%;
    background: radial-gradient(circle at 35% 35%,
            rgba(158, 76, 246, 0.85) 0%,
            rgba(158, 76, 246, 0.45) 20%,
            rgba(158, 76, 246, 0.00) 70%);
    filter: blur(40px);
    opacity: 0.9;
    pointer-events: none;
    z-index: 0;

}

.stat_label {
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    color: #FFF;
}

.stat_value {
    font-weight: 700;
    line-height: 20px;
    color: #fff;
}

.stat_divider {
    width: 1px;
    height: 26px;
    background-color: #fff;
}

.region_section {
    display: flex;
    gap: 5px;
    align-items: center;
    margin-bottom: 10px;
}

.region_common_wrapper {
    font-size: 12px;
    font-weight: 500;
    line-height: 24px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    color: #fff;
    border-radius: 14px;
    height: 24px;
}

.blur_text {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: #210F03;
    filter: blur(2px);
    -webkit-filter: blur(2px);
}

.ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 4;
    display: -webkit-box;
    -webkit-box-orient: vertical
}
</style>